<template>

    <ValidationObserver v-slot="{ handleSubmit, valid }" ref="mainObserver">
        <form
            name="myf2g-login-credentials-form"
            id="myf2g-login-credentials-form"
            @submit.prevent="handleSubmit(submitForm)"
        >
            <div >
                <ValidationProvider name="username" rules="required"  v-slot="{ errors, validated, invalid }">
                <div class="form-field">
                    <label class="form-label" for="username">{{ words['myf2g.login.credentialsform.username.label'] }}</label>
                    <input type="text" id="username" class="overlay-input-text form-input" v-model="username" />
                    <template v-if="validated && invalid">
                        <span style="color:#FE4C6F;">{{ errors[0] }}</span>
                    </template>
                </div>
                </ValidationProvider>

                <ValidationProvider name="password" rules="required"  v-slot="{ errors, validated, invalid }">
                    <div class="form-field">
                        <label class="form-label" for="password">{{ words['myf2g.login.credentialsform.password.label'] }}</label>
                        <div class="element-password-change-password">
                            <input type="password" id="password" class="overlay-input-text form-input" v-model="password" />
                            <span class="element-not-match hidden">The password do not match</span>
                            <span class="eye-hide password-btn-eye not-display-pass-eye">
                                <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <desc>Created with Sketch.</desc>
                                    <g id="btn_eye_hide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Icon" transform="translate(0.000000, 6.000000)" fill="#008BCD">
                                            <path
                                                d="M20.4576842,0.1564 C18.2430175,3.2764 14.7527368,5.122 11.0015439,5.122 C7.24880702,5.122 3.7554386,3.2764 1.54077193,0.1564 L0.0316491228,0.1564 L0.156701754,0.3516 C2.57207018,4.1452 6.62778947,6.4092 11.0015439,6.4092 C15.3752982,6.4092 19.4279298,4.1452 21.8432982,0.35 L21.9683509,0.1548 L20.4576842,0.1548 L20.4576842,0.1564 Z"
                                                id="Fill-1"
                                            ></path>
                                            <polygon id="Fill-2" points="10.5310526 6.3248 10.5310526 9.6248 11.6889474 9.6248 11.6889474 6.3248"></polygon>
                                            <polygon id="Fill-3" points="15.0163509 5.4736 16.3718596 8.7844 17.4378947 8.3156 16.082386 5.0048"></polygon>
                                            <polygon id="Fill-4" points="18.8080702 3.3736 20.9281754 6.186 21.8402105 5.4468 19.7204912 2.6344"></polygon>
                                            <polygon id="Fill-5" points="6.04266667 4.986 4.82610526 8.45 5.91452632 8.8608 7.13147368 5.3968"></polygon>
                                            <polygon id="Fill-6" points="2.45435088 2.728 0.319578947 5.5592 1.23161404 6.2984 3.36677193 3.4672"></polygon>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            <span class="eye-view password-btn-eye">
                                <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <desc>Created with Sketch.</desc>
                                    <g id="btn_eye_view" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Icon" transform="translate(0.000000, 4.000000)" fill="#008BCD">
                                            <g id="Page-1" transform="translate(11.000000, 5.000000) scale(1, -1) translate(-11.000000, -5.000000) ">
                                                <path
                                                    d="M20.4576842,0.1564 C18.2430175,3.2764 14.7527368,5.122 11.0015439,5.122 C7.24880702,5.122 3.7554386,3.2764 1.54077193,0.1564 L0.0316491228,0.1564 L0.156701754,0.3516 C2.57207018,4.1452 6.62778947,6.4092 11.0015439,6.4092 C15.3752982,6.4092 19.4279298,4.1452 21.8432982,0.35 L21.9683509,0.1548 L20.4576842,0.1548 L20.4576842,0.1564 Z"
                                                    id="Fill-1"
                                                ></path>
                                                <polygon id="Fill-2" points="10.5310526 6.3248 10.5310526 9.6248 11.6889474 9.6248 11.6889474 6.3248"></polygon>
                                                <polygon id="Fill-3" points="15.0163509 5.4736 16.3718596 8.7844 17.4378947 8.3156 16.082386 5.0048"></polygon>
                                                <polygon id="Fill-4" points="18.8080702 3.3736 20.9281754 6.186 21.8402105 5.4468 19.7204912 2.6344"></polygon>
                                                <polygon id="Fill-5" points="6.04266667 4.986 4.82610526 8.45 5.91452632 8.8608 7.13147368 5.3968"></polygon>
                                                <polygon id="Fill-6" points="2.45435088 2.728 0.319578947 5.5592 1.23161404 6.2984 3.36677193 3.4672"></polygon>
                                            </g>
                                            <circle id="Oval-2" cx="11" cy="10.5" r="2.5"></circle>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                        </div>
                        <template v-if="validated && invalid">
                            <span style="color:#FE4C6F;">{{ errors[0] }}</span>
                        </template>
                        <template v-else-if="responseErrorLevel != 0">
                            <span style="color:#FE4C6F;" v-html="responseErrorMessage"></span>
                        </template>
                    </div>
                </ValidationProvider>
                <div class="text-align-center">
                    <div class="overlay-button-container button-register">
                        <input id="myf2g-credentials-login" name="myf2g-credentials-login" type="submit" class="container-button" :class="[valid ? 'blue-btn' : 'grey-btn']" :disabled="!valid" :value="words['myf2g.login.credentialsform.submit.button']" />
                    </div>
                    <div v-on:click="goToForgotPassword()" class="cursor-hand paragr-text">{{ words['myf2g.login.credentialsform.registration.title'] }}</div>
                    <div class="descr-nologin">{{ words['myf2g.login.credentialsform.registration.paragraph.part1'] }} <a :href="'/'+urlLocale+'/f2g/registration-page/'" class="mini-title-blue">{{ words['myf2g.login.credentialsform.registration.paragraph.part2'] }}</a></div>
                </div>
            </div>
        </form>
    </ValidationObserver>

</template>

<script>

import store from '../store/store'
import _ from 'lodash'

export default {
  name: 'CredentialsForm',
  data: function() {
      return {
          words: {},
          username: '',
          password: '',
          responseErrorLevel: 0,
          responseErrorMessage: '',
          responseErrorCode: 0,
          validatedOnce: false,
          isComponentLoaded: false
      }
  },
  computed: {
      tai() {
          return store.state.tai;
      },
      locale() {
          return store.state.locale;
      },
      credentialsFormWords() {
          return store.state.credentialsFormWords;
      },
      urlLocale() {
          if (this.locale == "en_US") {
              return "en";
          } else {
              return "gr";
          }
      }
  },
  watch: {
    username() {
        this.responseErrorLevel = 0;
        this.responseErrorCode = 0;
        this.responseErrorMessage = '';
        
        var self = this;
        if (!this.validatedOnce) {
            if (this.username.length > 0 && this.password.length > 0) {
                this.$refs.mainObserver.validate().then(function(response){
                    self.validatedOnce = true;
                })
            }
        } else {
            this.$refs.mainObserver.validate();
        }
    },
    password() {
        this.responseErrorLevel = 0;
        this.responseErrorCode = 0;
        this.responseErrorMessage = '';

        var self = this;
        if (!this.validatedOnce) {
            if (this.username.length > 0 && this.password.length > 0) {
                this.$refs.mainObserver.validate().then(function(response){
                    self.validatedOnce = true;
                })
            }
        } else {
            this.$refs.mainObserver.validate();
        }
    },
    isComponentLoaded() {
        console.log("isComponentLoaded: "+this.isComponentLoaded);
        if (this.isComponentLoaded) {
            var self = this;
            this.$nextTick(function(){
                console.log("nexttick called");
                self.bindJSFunctionality();               
            })
        }
    }
  },
  beforeMount() {
    
    if ( sessionStorage.getItem("wcs_myf2glogincredentialsform_"+this.locale) != null ) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2glogincredentialsform_"+this.locale));
      this.isComponentLoaded = true;
      console.log("isComponentLoaded beforemount: "+this.isComponentLoaded);
    } else {
      
      let config = {
        method: 'get',
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2glogincredentialsform',
          locale: this.locale,
        }
      }
      
      let self = this;
      this.axios(config).then(function(response){
        console.log(response);
        self.words = response.data;
        sessionStorage.setItem("wcs_myf2glogincredentialsform_"+self.locale, JSON.stringify(self.words));
        self.isComponentLoaded = true;
        console.log("isComponentLoaded beforemount: "+self.isComponentLoaded);
      }).catch(function(error){
        console.error(error);
      })

    }
    
  },
  methods: {
    submitForm() {
      //constract the request
      let request = {}

      //construct the caller
      request.caller = {};
      request.caller.callingSystem = "myF2Gweb";
      request.caller.salesCode = "";
      request.caller.username = "anonymous";
      request.caller.locale = this.locale;
      request.caller.channel = "F2G";
    
      //construct the request info
      request.password = this.password;
      request.username = this.username;
      request.tai = this.tai;

      //construct the axios configuration
      let config = {
        method: 'post',
        url: '/apiv2/login/credentialsLogin/',
        data: request
      }

      let self = this;
      //show loader

      this.axios(config).then(function(response){
        console.log(response);

        if (response.data.errorLevel == 0) {
          
          handleDataLayer.init();
          handleDataLayer.pushSimpleDataLayer("myf2glogin");
          //Handle Success Case
          sessionStorage.setItem("keepAliveTimestamp", Date.now());
          window.location.href = response.data.redirectLocation;

        } else {
          //Handle Error Case
          self.responseErrorLevel = response.data.errorLevel;
          self.responseErrorMessage = response.data.errorMessage;
          self.responseErrorCode = response.data.errorCode;
        }

        
      }).catch(function(error){
        console.error(error);
      }).then(function(){
        //Hide loader
      })


    },
    goToForgotPassword() {
        if (this.locale == "en_US") {
            window.location.href = "/en/f2g/forgot-password/";
        } else {
            window.location.href = "/gr/f2g/forgot-password/";
        }
    },
    bindJSFunctionality() {

        console.log("bindJSFunctionality called");
        $('.password-btn-eye').on('click', function() {
        
            if($(this).parent().find('.overlay-input-text').prop("type") == "password"){
        
                $(this).parent().find('.overlay-input-text').attr('type', 'text');
                $(this).parent().find('.eye-hide').removeClass("not-display-pass-eye");
                $(this).parent().find('.eye-view').addClass("not-display-pass-eye");

            }else{

                $(this).parent().find('.overlay-input-text').attr('type', 'password');
                $(this).parent().find('.eye-view').removeClass("not-display-pass-eye");
                $(this).parent().find('.eye-hide').addClass("not-display-pass-eye");
            }

        })

        console.log("eye-show-hide bind");

        $('input').focus(function(){
          $(this).parents('.form-field').addClass('focused');
        });
        
        $('input').blur(function(){
          var inputValue = $(this).val();
          if ( inputValue == "" ) {
          $(this).removeClass('filled');
          $(this).parents('.form-field').removeClass('focused');  
          } else {
          $(this).addClass('filled');
          }
        })

        console.log("focus-blur bind");
    }
  }
}
</script>

